<script setup lang="ts">
import { computed } from 'vue'
import { Icon } from '@iconify/vue'

interface Props {
  data: object | string | number
  cellConfig: Object,
  tableConfig: Object,
}

const props = defineProps<Props>()

const buttons = computed(() => props.tableConfig.rowActionButtons)
const isShow = computed(() => {
  console.log('props.data', props.data)
  return props.data?.status === 'requested'
})

</script>

<template>
<!--{{props.tableConfig.rowActionButtons.action()}}-->
  <button v-if="isShow" v-for="btn in buttons" :key="btn.label" @click="(e: Event) => btn.action(e, props.data)" :class="`flex items-center gap-2 ${btn.css}`">
    <Icon v-if="btn.icon" :icon="btn.icon"></Icon>
    {{btn.label}}
  </button>
  <div v-else>
    <span class="text-gray-500">-</span>
  </div>
</template>

<style scoped>

</style>
